firebird.factory('mobileVersionAPIService', [
    '$q',
    '$resource',
    'helperService',
    function ($q, $resource, helperService) {
        var endpoint = helperService.getAPIUrl() + '/MobileVersion';

        var service = {
            checkForAppUpdates: checkForAppUpdates
        };

        return service;

        ////////////////////////

        function checkForAppUpdates(params) {
            var deferred = $q.defer();

            var paramDefaults = {
                version: '@version',
                deviceOS: '@deviceType'
            };

            $resource(endpoint, paramDefaults)
                .get(params)
                .$promise.then(
                    function (results) {
                        // Example return object:
                        // {
                        //   "type": "mandatory",
                        //   "version": 2,
                        //   "message": "We've made some big changes. An app update is required to continue using AnyMeeting.",
                        //   "downloadUrl": "",
                        //   "linkTitle": "Update Now",
                        //   "updateAvailable": true
                        // }
                        deferred.resolve(results);
                    },
                    function (err) {
                        deferred.reject(err);
                    }
                );

            return deferred.promise;
        }
    }
]);
